/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamAgentControlStateResponse } from './oralExamAgentControlStateResponse';

export type GenericApiResponseOralExamAgentControlStateResponseData = OralExamAgentControlStateResponse | null;
